/** @typedef {'essentiel' | 'serenite'} PlanId */

export const PENDING_PLAN_SESSION_KEY = 'leaseoptimizer_pending_plan'

export const PLAN_OPTIONS = [
  {
    id: 'essentiel',
    title: 'Essentiel',
    hint: '20 € + 5 % sur l’économie annuelle équivalente — vous négociez, nous guidons',
  },
  {
    id: 'serenite',
    title: 'Sérénité',
    hint: '20 € + 15 % sur l’économie annuelle équivalente — prise en charge complète',
  },
]

/**
 * @param {string | undefined} id
 * @returns {PlanId}
 */
export function normalizePlanId(id) {
  const s = (id || '').toLowerCase()
  if (s === 'serenite' || s === 'sérénité') return 'serenite'
  return 'essentiel'
}

/**
 * @param {PlanId | string} planId
 */
export function persistPendingPlan(planId) {
  sessionStorage.setItem(PENDING_PLAN_SESSION_KEY, normalizePlanId(planId))
}

/**
 * @returns {PlanId | null}
 */
export function readAndClearPendingPlan() {
  const raw = sessionStorage.getItem(PENDING_PLAN_SESSION_KEY)
  sessionStorage.removeItem(PENDING_PLAN_SESSION_KEY)
  return raw === 'serenite' || raw === 'essentiel' ? raw : null
}

/**
 * @param {Record<string, unknown> | null | undefined} result
 * @param {string} planKey
 */
export function planPricingFor(result, planKey) {
  const pp = result?.plan_pricing
  if (pp?.[planKey]?.amount != null) {
    return pp[planKey]
  }
  const c = result?.commission || {}
  return {
    amount: Number(c.amount ?? 0),
    net_savings_for_client: c.net_savings_for_client,
    fixed_eur: null,
    variable_pct: null,
  }
}
